import { useMutation } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { useJobRefetch } from '@hooks/job/refetch';
import { DefaultApiResp } from '@root/globalTypes';
import { AddScheduleDaysReq } from './types';

export const useAddScheduleDays = ({ callback }: { callback: (data: DefaultApiResp) => void }) => {
  const { refetch } = useJobRefetch({ schedule: { type: 'internal', action: 'create' } });

  const { mutate, isPending } = useMutation({
    mutationFn: (data: AddScheduleDaysReq): Promise<DefaultApiResp> =>
      queryFetch({
        url: 'internal_multischedules/add_days',
        data: data as unknown as Record<string, unknown>,
        opt: { method: 'POST' },
      }),
    onError: (err) => {
      console.error(err);
    },
    onSuccess: async ({ success }) => {
      if (!success) return;
      await refetch();
    },
    onSettled: (data) => {
      if (data) callback(data);
    },
  });

  return { mutate, isLoading: isPending };
};
